import React, { useState } from "react";

// Extracted MenuButton component
const MenuButton = ({ children, isActive, isAssetLink, title, onClick, ...otherProps }) => {
    const buttonClasses = `tw-w-full resource-library-menu-button2
    ${isActive ? "resource-library-menu-button-active" : ""}
    `;

    return (
        <button
            {...otherProps}
            title={title}
            className={buttonClasses}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

const MenuMobile = ({
    activeMenuId = -1,
    menuItems,
    activeMenuName,
    mobileLabels,
    breadCrumb,
    seeAllVisible,
    tracking,
    label = "",
    globalTopic = "",
    seeAll,
    onItemClick = (item = {}) => { },
    goBack = null,
    setFilterTrigger
}) => {


    return (
        <section className={`tw-w-full tw-max-w-full tw-py-12 tw-pt-0 md:tw-p-[40px]`} >

            <div className={`${mobileLabels.length > 1 ? "tw-flex " : "tw-none "}tw-my-8`}>
                {mobileLabels.length > 1 && (
                    mobileLabels.map((item, index) => {
                        // Replace dashes with spaces and capitalize each word
                        const formattedItem = item
                            .split('-')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');

                        const nonConditionalClasses = 'resource-library-menu-h2 tw-text-[14px] tw-font-normal tw-mb-0';
                        const conditionalClass = index !== mobileLabels.length - 1 ? 'tw-underline' : '';

                        const handleClick = index !== mobileLabels.length - 1 ? () => breadCrumb(index) : null;

                        return (
                            <React.Fragment key={index}>
                                <p className={`${nonConditionalClasses} ${conditionalClass}`} onClick={handleClick}>{formattedItem}</p>
                                {index < mobileLabels.length - 1 && <p className={`tw-px-2 tw-mb-0`}>></p>}
                            </React.Fragment>
                        );
                    })
                )}
            </div>

            {globalTopic && (
                <div className="tw-font-sans tw-font-bold tw-mb-2 tw-text-[18px]">
                    {globalTopic.replace("All ", "")}
                </div>
            )}

            <div className = "tw-flex tw-flex-row tw-justify-between tw-items-center tw-mb-[20px]">
                <h2 className="tw-bg-none !tw-m-0 !tw-p-0 tw-text-[33px]">{activeMenuId === -1 ? "All Topics" : activeMenuName}</h2>
            </div>

            {menuItems.map((item) => (
                <MenuButton
                    key={item.id}
                    title={item.name}
                    isActive={item.id === activeMenuId && !item.children.length}
                    isAssetLink={item.children?.length}
                    onClick={() => {
                        if (activeMenuId == 1360 && item.name != 'Powertrain') {
                            setFilterTrigger(false);
                        }
                        onItemClick(item);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                >
                    {item.name}
                    <span className="icon-right-arrow tw-text-[8px] tw-text-[#5482ab]"></span>
                </MenuButton>
            ))}

            <h2
                {...(goBack ? { role: "button" } : {})}
                className="resource-library-menu-h2 !tw-mt-12 tw-text-right tw-block tw-text-[#5482ab] tw-text-[14px]"
                onClick={() => (goBack ? goBack() : null)}
            >
                {goBack && tracking > 0 ? (
                    <span className="icon-left-arrow tw-text-[8px] tw-inline-block tw-mr-2 tw--ml-6"></span>
                ) : null}
                {label}
            </h2>

        </section>
    );
};

export default MenuMobile;